import { useMemo } from "react";
import PropTypes from "prop-types";

import useLanguageChange from "../../hooks/useLanguageChange";

import CenterModal from "../UI/Modal/CenterModal";

// Cancel upload modal
const CancelUploadModal = ({ onCloseCancelUploadModal, onConfirmCancelMarkup }) => {
    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change*/
    const localisedValues = useLanguageChange();

    const onCloseHandler = () => {
        onCloseCancelUploadModal();
    };

    const onConfirmHandler = () => {
        onConfirmCancelMarkup();
    };

    const header = useMemo(() => {
        return (
            <>
                <h5 className='modal-title'>{localisedValues?.cancel_upload_alert}</h5>
                <button type='button' className='btn-close' onClick={() => onCloseHandler()} aria-label='Close'>
                    <span className='btn-icon icon-close-light'></span>
                </button>
            </>
        );
    }, [localisedValues]);

    const body = useMemo(() => {
        return (
            <div className='privacy-policy-modal-text'>
                <p>{localisedValues?.file_details_deleted}</p>
            </div>
        );
    }, [localisedValues]);

    const footer = useMemo(() => {
        return (
            <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
                <div className='button'>
                    <button className='btn default-btn-link' onClick={() => onCloseHandler()}>
                        {localisedValues?.close}
                    </button>
                </div>
                <div className='button'>
                    <button className='btn default-btn-primary' onClick={() => onConfirmHandler()}>
                        {localisedValues?.cancel_upload}
                    </button>
                </div>
            </div>
        );
    }, [localisedValues]);

    return (
        <CenterModal
            showModal={true}
            closeModal={onCloseHandler}
            modalClass='default-modal modal-small mob-bottom-top'
            className='modal-dialog-centered'
            bodyClassName='default-custom-scroll'
            header={header}
            body={body}
            footer={footer}
            keyboard={true}
            backdrop={"static"}
        />
    );
};

CancelUploadModal.propTypes = {
    onCloseCancelUploadModal: PropTypes.func,
    onConfirmCancelMarkup: PropTypes.func,
};

export default CancelUploadModal;
